<template>
  <!-- 所有页面 回到顶部组件 -->
  <!-- <div v-show="isShow" class="gotop">
    <div @click="goTop" ref="goTop" class="icon_ignore goTop">
      <div class="qrcode">
        <img src="../../assets/image/top_qrcode.png" alt="">
      </div>
      <img src="../../assets/image/top.png" alt />
    </div>
  </div>-->
  <div class="gotop">
    <div class="goTop" ref="goTop" :class="!isclose ? 'goTop2' : ''" >
      <div class="qrcode" v-show="!isclose">
        <img class="close"  @click="closeQrcode" src="../../assets/image/top_close.png" alt="">
        <img src="../../assets/image/qrcode.gif" alt />
      </div>
      <div  class="top_icon" @click="goTop" v-show="isShow" >
        <img class="arrow" src="../../assets/image/goTop.svg" alt />
      </div>
    </div>
  </div>
</template>

<script>
//  节流插件
import throttle from "lodash/throttle";
export default {
  name: "GoTop",
  data() {
    return {
      // 是否显示组件
      isShow: false,
      // 页面滚动距离
      scrollTop: 0,
      timer: null,
      isclose:false,
    };
  },
  props:{
      showQrcode:{
        type:Boolean,
        default:false
      },
      type:{
        type:String,
        default:''
      }
  },
  mounted() {
    // 监听页面滚动
    document.addEventListener("scroll", this.listenScroll);
  },
  beforeDestroy() {
    // 解除监听
    document.removeEventListener("scroll", this.listenScroll);
    // 每次离开当前界面时，清除定时器
    clearInterval(this.timer);
  },
  methods: {
    // 回到顶部
    goTop() {
      const that = this;
      that.timer = setInterval(() => {
        const ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        const nowtop = that.scrollTop + ispeed;
        // console.log(nowtop)
        window.scrollTo(0, nowtop);
        if (that.scrollTop === 0) {
          clearInterval(that.timer);
        }
      }, 16);
    },
    // 滚动监听 判断是否显示组件
    listenScroll: throttle(function() {
      // console.log(this)
      const that = this;
      const scrHeight =
        document.documentElement.scrollTop || window.pageYOffset;
      that.scrollTop = scrHeight;
      if (that.scrollTop > 1200) {
        that.isShow = true;
      } else {
        that.isShow = false;
      }
    }, 16),
    // 关闭二维码
    closeQrcode(){
         this.isclose=true
    }
  }
};
</script>

<style scoped lang="stylus">
.gotop {
  position: relative;
  z-index: 99999999;
   .goTop2{
    height: 300px;
    bottom: 100px !important;
  }
 
  .goTop {
    position: fixed;
    right: 30px;
    bottom: 200px;
    cursor: pointer;
    z-index: 999999;
    display: block;
    display: flex;
    flex-direction: column;
    align-items: center;

    .qrcode {
      width: 150px;
      height: 200px;
      margin-bottom:10px;
      .close{
        position :absolute;
        width :18px;
        height 18px;
        top :-26px;
        right:0px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }

    .top_icon {
      overflow:hidden;
      opacity: 0.8;
      width: 50px;
      height: 50px;
      background: #FFFFFF;
      box-shadow: 0px 2px 10px 0px rgba(215, 215, 215, 0.5);
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;

      .arrow {
        width: 19px;
        height: 25px;
        filter: drop-shadow(#BEBEBE 100px 0);
        transform: translateX(-100px);
      }
      &:hover {
          opacity: 1;
          .arrow{
            filter: drop-shadow(#014EA2 100px 0);
          }
        }
    }
  }
}
</style>
